import type { Ref } from "vue";

import { useQuery } from "@pinia/colada";
import { computed } from "vue";

import type { LocaleMorpheus } from "@solvari/translations";

import type { CmsLocalSearch } from "~/features/company-wall/api/localSearchCms.api.ts";

import { useGeoProductCategory } from "~/features/company-wall/api/localSearch.api.ts";
import { provideContentParams } from "~/shared/composables/useContentParams.ts";

function useProvideContentParams(params: {
  locale: LocaleMorpheus;
  localSearch: Readonly<Ref<CmsLocalSearch | null | undefined>>;
  slug: string;
}) {
  const { data: geoProductCategory } = useQuery(
    useGeoProductCategory({ slug: params.slug, localeCode: params.locale }),
  );

  provideContentParams(
    computed(() => ({
      productSg: params.localSearch.value?.productSingular ?? params.slug,
      productPl: params.localSearch.value?.productPlural ?? params.slug,
      customerSg: params.localSearch.value?.customerSingular ?? undefined,
      customerPl: params.localSearch.value?.customerPlural ?? undefined,
      totalCustomers: geoProductCategory.value?.totalCustomers,
      totalReviews: geoProductCategory.value?.totalReviews,
      reviewScore: geoProductCategory.value?.averageRating,
      totalLeads: geoProductCategory.value?.totalLeads,
    })),
  );
}

export { useProvideContentParams };
